import { noop } from 'lodash';
import { createContext } from 'use-context-selector';

import {
  BaseFieldOnBlurHandler,
  BaseFieldEnterKeyHint,
  BaseFieldOnFocusHandler,
  BaseFieldOnKeyUpHandler,
  BaseFieldOnKeyDownHandler,
  BaseFieldOnCompositionUpdateHandler,
} from '../Fields.types';

interface FieldPatternContextProps {
  placeholder: string;
  invalid: boolean;
  error: string;
  value: string;
  onBlur: BaseFieldOnBlurHandler;
  enterKeyHint: BaseFieldEnterKeyHint;
  disabled: boolean;
  onFocus: BaseFieldOnFocusHandler;
  onKeyUp: BaseFieldOnKeyUpHandler;
  onKeyDown: BaseFieldOnKeyDownHandler;
  onCompositionUpdate: BaseFieldOnCompositionUpdateHandler;
}

export const FieldPatternContext = createContext<FieldPatternContextProps>({
  placeholder: '',
  invalid: false,
  error: '',
  value: '',
  onBlur: noop,
  enterKeyHint: 'enter',
  disabled: false,
  onFocus: noop,
  onKeyUp: noop,
  onKeyDown: noop,
  onCompositionUpdate: noop,
});
